import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// ruta a los archivos de idiomas
import common_en from "./locales/en/common.json";
import common_es from "./locales/es/common.json";
import {LocaleService} from "./common/LocaleService";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: (code: string) => {
            return LocaleService.filterLangValue(code); // fallback to Spanish if no match
        },
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react!!
        },
        // react i18next special options (optional)
        react: {
            // OJO: aqui habia tambien `wait: false`, que react-i18next dejo de
            // admitir hace varias versiones, y `bindStore: "added removed"`,
            // que es un typo de `bindI18nStore`. Los dos se ignoraban, asi que
            // los eventos del store nunca han disparado repintado. Se quitan
            // sin sustituirlos para no cambiar el comportamiento.
            bindI18n: "languageChanged loaded",
            nsMode: "default",
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'ul', 'li', 'em', 'a']
        },
        resources: {
            es: {
                translation: common_es,
            },
            en: {
                translation: common_en,
            },
        },
    })
export default i18n;
